import React, { Component } from 'react';
import RDP_CONFIG from "../../config"
import {UserService} from '../../services/user';
import {VideoPlayer} from '../../components';
import './element-video.css';

export default class ElementVideo extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(content) {
    this.props.onChange(content);
  }

  getVideoUrl(video) {
    var accessToken = UserService.getUser().access_token;
    if (video !== "https://pocs.digitalpages.com.br/rdpcomposer/media/video-1/video-1.mp4") {
      video += "&access_token=" + accessToken + "&project_key=" + RDP_CONFIG.projectKey;
    };
    return video;
  }

  getSubtitlesUrl(subtitles) {
    if (!subtitles) return null;
    var accessToken = UserService.getUser().access_token;
    if (subtitles.indexOf('?') > -1) {
      return subtitles + "&access_token=" + accessToken + "&project_key=" + RDP_CONFIG.projectKey;
    }
    return subtitles + "?access_token=" + accessToken + "&project_key=" + RDP_CONFIG.projectKey;
  }

  render() {
    let { headerActionsTemplate, footerActionsTemplate, content } = this.props;
    var imageStyle = {
      background: content.background_color,
      paddingTop: content.padding_top + "px",
      paddingBottom: content.padding_bottom + "px"
    }
    const videoJsOptions = {
      responsive: true,
      autoplay: true,
      controls: true,
      playbackRates: [0.5, 1, 1.5, 2],
      sources: [{
        src: this.getVideoUrl(content.video)
      }]
    }

    return (<div className={this.props.className} style={imageStyle}>
      {headerActionsTemplate}
      {/* <VideoPlayer { ...videoJsOptions } /> */}
      <video controls src={this.getVideoUrl(content.video)} crossOrigin="anonymous" aria-describedby={content.transcript ? `${content.id}-transcript` : undefined}>
        {content.subtitles && <track kind="subtitles" src={this.getSubtitlesUrl(content.subtitles)} srcLang="pt-BR" label="Português" default />}
      </video>
      {content.transcript && (
        <div className="rdp-video-transcript" style={{ marginTop: '10px', padding: '10px', fontSize: '14px', lineHeight: '1.6' }}>
          <details>
            <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>Transcrição</summary>
            <p id={`${content.id}-transcript`} style={{ marginTop: '10px', whiteSpace: 'pre-wrap' }}>{content.transcript}</p>
          </details>
        </div>
      )}
      {footerActionsTemplate}
    </div>)
  }
}
